export const captureRecoveryMessages = {
  'zh-CN': {
    'source-endedTitle': '共享已结束，请重新选择当前游戏窗口',
    'source-endedHint': '关闭或重开游戏窗口后，需要重新选择共享源，无需刷新网页。切换账号时，请先结束上一条记录，再为新账号开始记录。',
    'permission-deniedTitle': '未获得窗口共享授权',
    'security-restrictedTitle': '窗口共享受到安全或权限限制',
    'security-restrictedHint': '请检查浏览器、系统或组织的共享权限设置，然后重新选择游戏窗口。',
    'invalid-stateTitle': '请回到当前页面重新选择',
    'invalid-stateHint': '请切回当前页面，并重新点击“选择游戏窗口”以发起共享。',
    'insecure-contextTitle': '当前页面无法安全地发起共享',
    'insecure-contextHint': '窗口共享需要安全连接，请通过 HTTPS 打开枫记官网后重试。',
    'embeddedTitle': '请在独立标签页打开枫记',
    'embeddedHint': '当前页面处于内嵌框架中，请在独立浏览器标签页中打开后再共享窗口。',
    'mobileTitle': '请用电脑进行实时识别',
    'mobileHint': '支持 Windows 版 Edge / Chrome / Firefox，手机可浏览历史记录和排行榜。',
    mobileCopyLink: '复制链接',
    'policy-blockedTitle': '当前页面不允许窗口共享',
    'policy-blockedHint': '请在独立标签页打开枫记后重试；若仍然失败，请检查浏览器或组织的共享限制。',
    openOfficial: '通过 HTTPS 打开官网',
    openStandalone: '在独立标签页打开',
    browserHelp: '浏览器升级与更换帮助',
    updateSteps: '复制下面的地址，粘贴到浏览器地址栏并打开，检查 {browser} 更新；更新完成后重启浏览器再试。',
    updateMenu: '请通过浏览器菜单中的“帮助”或“关于”检查更新，或改用最新版桌面 Edge / Chrome / Firefox。',
    copyUpdateAddress: '复制更新地址',
    downloadEdge: '下载 Microsoft Edge',
    downloadChrome: '下载 Google Chrome',
    downloadFirefox: '下载 Firefox（火狐浏览器）',
    copyPageLink: '复制当前页面链接',
    linkCopied: '地址已复制，请粘贴到浏览器地址栏打开。',
    linkCopyFailed: '自动复制失败，请手动选择并复制下方地址。',
    manualAddress: '可手动复制的地址',
    screenSteps: '点击下方按钮，在浏览器共享弹窗中选择「整个屏幕」，选中游戏所在的屏幕，再点击「共享」。',
    tryScreen: '尝试采集整个屏幕',
    retryScreen: '重试整屏采集',
    screenFailed: '整屏采集也未能启动',
    attemptFailed: '这次采集仍未启动',
    retryHint: '请先完全退出浏览器后重开，或改用最新版 Edge / Chrome / Firefox，再尝试采集。',
    screenHint: '请让游戏尽量铺满所选屏幕，并保持可见，避免最小化或被其他窗口遮挡。连接后检查等级和经验；识别不准确时，请调整识别区域。',
    more: '更多排查方法',
    windowMode: '将游戏切换为窗口化或无边框模式，并保持游戏画面可见。',
    factoryReset: '到设置页执行「恢复出厂设置」，然后重新连接画面。',
    updateBrowser: '将当前浏览器更新到最新版本。',
    browser: '完全退出浏览器后重开，或改用最新版 Microsoft Edge / Google Chrome / Firefox。',
    driver: '仍无法连接时，重启电脑并更新显卡驱动和 Windows。若有录屏、直播或远程桌面正在运行，也可关闭后重试。',
    compare: '可以选择记事本等普通窗口作对照：只有游戏失败时，优先检查游戏显示模式；所有来源都失败时，优先检查浏览器和系统。',
    copy: '复制诊断信息',
    copied: '诊断信息已复制',
    copyFailed: '自动复制失败，请手动选择并复制下方诊断信息。',
    diagnostic: '采集诊断信息',
  },
  en: {
    'source-endedTitle': 'Sharing ended. Choose the current game window again',
    'source-endedHint': 'After closing or reopening the game window, select the source again without reloading this page. When switching accounts, finish the previous record before starting one for the new account.',
    'permission-deniedTitle': 'Window sharing permission was not granted',
    'security-restrictedTitle': 'Window sharing is restricted by security or permissions',
    'security-restrictedHint': 'Check the sharing permissions in your browser, operating system, or organization, then choose the game window again.',
    'invalid-stateTitle': 'Return to this page and choose again',
    'invalid-stateHint': 'Switch back to this page and click “Choose game window” again to start sharing.',
    'insecure-contextTitle': 'This page cannot start sharing securely',
    'insecure-contextHint': 'Window sharing requires a secure connection. Open the official Maple Log site over HTTPS and try again.',
    'embeddedTitle': 'Open Maple Log in its own tab',
    'embeddedHint': 'This page is inside an embedded frame. Open it in a separate browser tab before sharing a window.',
    'mobileTitle': 'Use a computer for live recognition',
    'mobileHint': 'Use Edge / Chrome / Firefox on Windows. History and ranks are available on mobile.',
    mobileCopyLink: 'Copy link',
    'policy-blockedTitle': 'Window sharing is not allowed on this page',
    'policy-blockedHint': 'Open Maple Log in a separate tab and try again. If it still fails, check browser or organization sharing restrictions.',
    openOfficial: 'Open the official HTTPS site',
    openStandalone: 'Open in a separate tab',
    browserHelp: 'Browser update and switching help',
    updateSteps: 'Copy the address below, paste it into the browser address bar, and open it to check for {browser} updates. Restart the browser after updating.',
    updateMenu: 'Check for updates through Help or About in your browser menu, or use the latest desktop Edge / Chrome / Firefox.',
    copyUpdateAddress: 'Copy update address',
    downloadEdge: 'Download Microsoft Edge',
    downloadChrome: 'Download Google Chrome',
    downloadFirefox: 'Download Firefox',
    copyPageLink: 'Copy this page link',
    linkCopied: 'Address copied. Paste it into the browser address bar to open it.',
    linkCopyFailed: 'Automatic copying failed. Select and copy the address below manually.',
    manualAddress: 'Address for manual copying',
    screenSteps: 'Click the button below. In the browser sharing dialog, choose “Entire screen”, select the screen containing the game, then click “Share”.',
    tryScreen: 'Try capturing the entire screen',
    retryScreen: 'Retry screen capture',
    screenFailed: 'Entire-screen capture could not start either',
    attemptFailed: 'This capture attempt still could not start',
    retryHint: 'Fully quit and reopen the browser, or try the latest Edge / Chrome / Firefox before capturing again.',
    screenHint: 'Let the game fill as much of the selected screen as possible and keep it visible, without minimizing it or covering it with other windows. Check the level and EXP after connecting; adjust the recognition regions if needed.',
    more: 'More troubleshooting steps',
    windowMode: 'Switch the game to windowed or borderless mode and keep the game visible.',
    factoryReset: 'Open Settings, restore factory settings, then try connecting the game frame again.',
    updateBrowser: 'Update this browser to the latest version.',
    browser: 'Fully quit and reopen the browser, or try the latest Microsoft Edge / Google Chrome / Firefox.',
    driver: 'If capture still fails, restart the computer and update the graphics driver and Windows. If recording, streaming, or remote-desktop tools are running, also try closing them.',
    compare: 'Try a regular window such as Notepad: if only the game fails, check its display mode first; if every source fails, check the browser and system first.',
    copy: 'Copy diagnostics',
    copied: 'Diagnostics copied',
    copyFailed: 'Automatic copying failed. Select and copy the diagnostics below manually.',
    diagnostic: 'Capture diagnostics',
  },
} as const
